import Swal from "sweetalert2";

export function handleToast({
  title,
  text,
  dispatcher,
  icon = "warning",
  confirmButtonText = "Eliminar",
  cancelButtonText = "Cancelar",
}) {
  Swal.fire({
    title,
    text,
    icon,
    reverseButtons: true,
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    cancelButtonText,
    confirmButtonText,
  }).then((result) => dispatcher(result));
}

export function handleConfirmDialog({
  title = "¿Estás seguro que deseas cambiar la contraseña?",
  text = "",
  dispatcher,
  confirmButtonText = "Aceptar",
  cancelButtonText = "Atrás",
  width = 650,
}) {
  Swal.fire({
    title,
    text,
    showCancelButton: true,
    confirmButtonText,
    cancelButtonText,
    reverseButtons: false,
    buttonsStyling: false,
    allowOutsideClick: true,
    allowEscapeKey: true,
    width,
    background: "#fff",
    padding: "1.5rem",
    didOpen: () => {
      const popup = Swal.getPopup();
      const titleEl = Swal.getTitle();
      const confirmBtn = Swal.getConfirmButton();
      const cancelBtn = Swal.getCancelButton();

      if (popup) {
        popup.style.borderRadius = "12px";
        popup.style.boxShadow = "0 4px 12px rgba(0,0,0,0.12)";
        popup.style.textAlign = "center";
      }
      if (titleEl) {
        titleEl.style.fontSize = "1.25rem";
        titleEl.style.fontWeight = "600";
        titleEl.style.marginBottom = "1.25rem";
      }
      if (confirmBtn) {
        confirmBtn.style.backgroundColor = "#2E7D8A"; // sólido
        confirmBtn.style.color = "#fff";
        confirmBtn.style.border = "none";
        confirmBtn.style.borderRadius = "8px";
        confirmBtn.style.padding = "10px 18px";
        confirmBtn.style.fontWeight = "600";
        confirmBtn.style.marginRight = "12px";
      }
      if (cancelBtn) {
        cancelBtn.style.backgroundColor = "transparent"; // outline
        cancelBtn.style.color = "#2E7D8A";
        cancelBtn.style.border = "2px solid #2E7D8A";
        cancelBtn.style.borderRadius = "8px";
        cancelBtn.style.padding = "8px 16px";
        cancelBtn.style.fontWeight = "600";
      }
    },
  }).then((result) => dispatcher?.(result));
}

// Nueva función para mostrar un select con opciones usando SweetAlert2 nativo
export async function handleSelectToast({
  title,
  text,
  options = [], // Array de strings con las opciones
  dispatcher,
  confirmButtonText = "Confirmar",
  cancelButtonText = "Cancelar",
  inputPlaceholder = "Selecciona una opción",
  initialValue = "", // Valor inicial del select
  required = true, // Si el campo es requerido
}) {
  // Convertir el array de opciones a objeto para inputOptions
  const inputOptions = {};
  options.forEach((option) => {
    inputOptions[option] = option;
  });

  try {
    const { value: selectedValue } = await Swal.fire({
      title,
      text,
      input: "select",
      inputOptions,
      inputPlaceholder,
      inputValue: initialValue, // Valor inicial
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText,
      confirmButtonText,
      reverseButtons: true,
      inputValidator: (value) => {
        return new Promise((resolve) => {
          // Verificar si es requerido y no hay valor
          if (required && !value) {
            resolve("Por favor selecciona una opción");
            return;
          }
          // Si todo está bien, resolver sin mensaje de error
          resolve();
        });
      },
    });

    // Si se seleccionó un valor, ejecutar el dispatcher
    if (selectedValue) {
      dispatcher({
        isConfirmed: true,
        selectedValue,
        value: selectedValue,
      });
    }
  } catch (error) {
    // Si se canceló o hubo error
    dispatcher({
      isConfirmed: false,
      isDismissed: true,
    });
  }
}
